import React from 'react';

/** Libellé menu graphe pour un document : titre + nom de fichier sur deux lignes, troncature CSS. */
export function u3141GraphContextMenuDocumentLabel(
  typeLabel: string,
  documentName?: string | null,
): { label: React.ReactNode; title: string } {
  const name = documentName?.trim() ?? '';
  if (!name) {
    return { label: typeLabel, title: typeLabel };
  }
  const full = `${typeLabel} — ${name}`;
  return {
    title: full,
    label: (
      <span className="flex min-w-0 flex-1 flex-col gap-0.5 text-left">
        <span className="truncate">{typeLabel}</span>
        <span className="truncate text-xs font-normal text-gray-500">{name}</span>
      </span>
    ),
  };
}
